import { render, staticRenderFns } from "./addReferResource.vue?vue&type=template&id=3172bb9d&scoped=true"
import script from "./addReferResource.vue?vue&type=script&lang=js"
export * from "./addReferResource.vue?vue&type=script&lang=js"
import style0 from "./addReferResource.vue?vue&type=style&index=0&id=3172bb9d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3172bb9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3172bb9d')) {
      api.createRecord('3172bb9d', component.options)
    } else {
      api.reload('3172bb9d', component.options)
    }
    module.hot.accept("./addReferResource.vue?vue&type=template&id=3172bb9d&scoped=true", function () {
      api.rerender('3172bb9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/child/addReferResource.vue"
export default component.exports